/**
 * What a message is about.
 *
 * The subject pair (`subject_type` + `subject_id`) replaces the case number as a thread's key. A case number
 * is `<client identifier>-<counter>` and an archived client's identifier can be reused, so two clients under
 * one firm can hold the same one — `subject_id` is always the subject document's Mongo id.
 */
export enum MessageSubjectType {
  EVICTION = 'EVICTION',
  INTAKE_EVICTION = 'INTAKE_EVICTION',
  CASE = 'CASE',
  NONE = 'NONE'
}

/** The URL segment each subject type is addressed by, in both the API and the portal routes. */
export const MESSAGE_SUBJECT_PATH: Record<MessageSubjectType, string | null> = {
  [MessageSubjectType.EVICTION]: 'eviction',
  [MessageSubjectType.INTAKE_EVICTION]: 'intake',
  [MessageSubjectType.CASE]: 'case',
  [MessageSubjectType.NONE]: null
};

const BY_PATH: Record<string, MessageSubjectType> = {
  eviction: MessageSubjectType.EVICTION,
  intake: MessageSubjectType.INTAKE_EVICTION,
  case: MessageSubjectType.CASE
};

/** The subject type a URL segment addresses, or undefined when the segment names no subject. */
export function messageSubjectTypeFromPath(segment: string | null | undefined): MessageSubjectType | undefined {
  return segment ? BY_PATH[segment.toLowerCase()] : undefined;
}
